import { Addresses } from "./addresses";
import { CompanyConfigGroups } from "./company-config-groups";


export class Company {
    id!: string;
    name!: string;
    rfc!: string;
    telephone!: string;
    cellPhone!: string;
    email!: string;
    addresses: Addresses | null | undefined = new Addresses();
    active: boolean = false;
    /*creationDate: string;
    modificationDate:string;
    creationUserId: string;
    modificationUserId: string;*/

    companyConfigGroups: CompanyConfigGroups | null | undefined = new CompanyConfigGroups();
}   